// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list.js';

import { paths } from '../generated/list';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list', Original, paths);
